import { TooltipPassThrough } from "primeng/types/tooltip";

export const TooltipTelekomPT: TooltipPassThrough = {
    text: {
        class: "border-1 border-transparent"
    }
};
